import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import Main from '@/views/layouts/main'

import ErrorLimit from '@/views/components/error-limit/index.component'
import { PlayerSearchModule } from '@/views/player-search'
import PageTitle from '@/views/layouts/page-title/index.layout'

const PlayerSearchPage = () => {
  const { t } = useTranslation()
  return (
    <Main paddingZero>
      <ErrorLimit>
        <Box sx={{ padding: 2 }}>
          <PageTitle title={t('pages.players')} />
        </Box>
        <Box sx={{ display: 'flex', padding: 2 }}>
          <PlayerSearchModule />
        </Box>
      </ErrorLimit>
    </Main>
  )
}

export default PlayerSearchPage
